import {
  Center,
  Text,
  VStack,
  SimpleGrid,
  Link,
  Button,
} from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'

import { NAVIGATION_BAR_HEIGHT } from '@/components/NavigationBar/constants'

import ContentImage from '@/images/resources/riskAssessment/content-1.svg'
import Content2Image from '@/images/resources/riskAssessment/content-2.svg'

import { RISK_ASSESSMENT_TYPEFORM } from '@/routes/external'

function RiskAsessmentContent(): React.ReactElement {
  const { t } = useTranslation('riskAssessment')

  return (
    <Center
      sx={{
        bg: 'secondary.800',
        w: 'full',
        minH: {
          base: `calc(100vh - ${NAVIGATION_BAR_HEIGHT.base})`,
          md: `calc(100vh - ${NAVIGATION_BAR_HEIGHT.md})`,
        },
      }}
    >
      <VStack
        layerStyle="container"
        spacing="40px"
        sx={{
          color: 'white',
          fontWeight: 'medium',
          textAlign: 'center',
        }}
      >
        <Text sx={{ fontSize: { base: 'lg', sm: '3.5xl' } }}>
          {t('contents.paragraph')}
        </Text>
        <SimpleGrid
          columns={{ base: 1, sm: 2 }}
          gap={{ base: 10, md: 16 }}
          sx={{ fontSize: { base: 'lg', sm: '2xl' }, py: 10 }}
        >
          <VStack sx={{ alignItems: 'stretch' }} spacing="4">
            <Image
              src={ContentImage}
              alt=""
              width="125px"
              height="125px"
              objectFit="contain"
            />
            <Text>{t('contents.list.0')}</Text>
          </VStack>
          <VStack sx={{ alignItems: 'stretch' }} spacing="4">
            <Image
              src={Content2Image}
              alt=""
              width="125px"
              height="125px"
              objectFit="contain"
            />
            <Text>{t('contents.list.1')}</Text>
          </VStack>
        </SimpleGrid>
        <Button
          as={Link}
          href={RISK_ASSESSMENT_TYPEFORM.pathname}
          isExternal={RISK_ASSESSMENT_TYPEFORM.isExternal}
          size="xl"
          sx={{
            color: 'white !important',
          }}
        >
          {t('cta')}
        </Button>
      </VStack>
    </Center>
  )
}

export default RiskAsessmentContent
